module.exports = __webpack_public_path__ + "media/coffee-preferences/cream_and_sugar_low-1e275261.png";